// Chakra data ordered ROOT -> CROWN. `top` is vertical position (% of being column).
export const CHAKRAS = [
  {
    id: "root", name: "Muladhara", english: "Root Chakra", frequency: 396, note: "C",
    color: "#FF2D55", glow: "rgba(255,45,85,0.75)", element: "Earth", petals: 4, symbol: "root",
    top: 55.5, affirmation: "I am grounded, safe, and centered in the cosmic stream.",
  },
  {
    id: "sacral", name: "Svadhisthana", english: "Sacral Chakra", frequency: 417, note: "D",
    color: "#FF9500", glow: "rgba(255,149,0,0.75)", element: "Water", petals: 6, symbol: "crescent",
    top: 49, affirmation: "My creative energy flows naturally without blockage.",
  },
  {
    id: "solar_plexus", name: "Manipura", english: "Solar Plexus", frequency: 528, note: "E",
    color: "#FFCC00", glow: "rgba(255,204,0,0.75)", element: "Fire", petals: 10, symbol: "triangle",
    top: 42.2, affirmation: "My inner fire radiates pure willpower and clarity.",
  },
  {
    id: "heart", name: "Anahata", english: "Heart Chakra", frequency: 639, note: "F",
    color: "#34C759", glow: "rgba(52,199,89,0.75)", element: "Air", petals: 12, symbol: "hexagram",
    top: 34.1, affirmation: "Unconditional love and compassion harmonize my being.",
  },
  {
    id: "throat", name: "Vishuddha", english: "Throat Chakra", frequency: 741, note: "G",
    color: "#5AC8FA", glow: "rgba(90,200,250,0.75)", element: "Ether", petals: 16, symbol: "circle-triangle",
    top: 30.5, affirmation: "I speak my divine truth with clarity and resonance.",
  },
  {
    id: "third_eye", name: "Ajna", english: "Third Eye", frequency: 852, note: "A",
    color: "#7C6BF5", glow: "rgba(124,107,245,0.8)", element: "Light", petals: 2, symbol: "om",
    top: 20, affirmation: "My vision sees beyond the veil of time and space.",
  },
  {
    id: "crown", name: "Sahasrara", english: "Crown Chakra", frequency: 963, note: "B",
    color: "#C77DFF", glow: "rgba(199,125,255,0.85)", element: "Divine Spirit", petals: 24, symbol: "om",
    top: 16.3, affirmation: "I am one with the infinite universal consciousness.",
  },
];

export const CHAKRA_BY_ID = Object.fromEntries(CHAKRAS.map((c) => [c.id, c]));
